var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentStatusUpdateUploadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7452_13888",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 11,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83203 11.3637H7.16536C6.7987 11.3637 6.4987 11.0637 6.4987 10.6971V7.36374H5.4387C4.84536 7.36374 4.55203 6.64374 4.97203 6.22374L8.03203 3.16374C8.15659 3.03891 8.32569 2.96875 8.50203 2.96875C8.67838 2.96875 8.84748 3.03891 8.97203 3.16374L12.032 6.22374C12.452 6.64374 12.152 7.36374 11.5587 7.36374H10.4987V10.6971C10.4987 11.0637 10.1987 11.3637 9.83203 11.3637ZM12.4987 12.6966H4.4987C4.13203 12.6966 3.83203 12.9966 3.83203 13.3633C3.83203 13.7299 4.13203 14.0299 4.4987 14.0299H12.4987C12.8654 14.0299 13.1654 13.7299 13.1654 13.3633C13.1654 12.9966 12.8654 12.6966 12.4987 12.6966Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7452_13888)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentStatusUpdateUploadArrow);
export default __webpack_public_path__ + "static/media/document-status-update-UploadArrow.a0ccfd5b5ca10f30d8b7caa3b8f19c92.svg";
export { ForwardRef as ReactComponent };